import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <Header />

      <main className="about-main">
        <div className="about-container">
          <h1>About Rec-Chord</h1>
          <p className="about-subtitle">
            Professional AI-powered transcription that puts accuracy and control in your hands.
          </p>

          {/* Hero Section */}
          <section className="about-hero-section">
            <div className="hero-content">
              <h2>Your Voice, Perfectly Penned</h2>
              <p>
                Rec-Chord is a next-generation transcription platform built for professionals who demand
                accuracy, speed, and complete control over their transcripts. Whether you're a content creator,
                journalist, researcher, or business professional, Rec-Chord transforms your audio
                into precise, editable text with word-level timestamps. Upload video files too — we automatically extract the audio for transcription.
              </p>
            </div>
          </section>

          {/* What Makes Us Different */}
          <section className="about-section features-section">
            <h2>What Makes Rec-Chord Different</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Confidence Scoring</h3>
                  <p>Every word color-coded by confidence level for quick review.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Precise Timestamps</h3>
                  <p>Click any word to jump to that exact moment in audio.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Inline Editing</h3>
                  <p>Edit words directly while preserving timing data.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Subtitle Export</h3>
                  <p>Export to SRT, VTT, ASS, or SBV formats.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Version History</h3>
                  <p>Auto-save with full history and restore options.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Easy Sharing</h3>
                  <p>Share with links and visual cards for social media.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Use Cases */}
          <section className="about-section">
            <h2>Built For Professionals</h2>
            <div className="use-cases-grid">
              <div className="use-case-card">
                <h3>Content Creators</h3>
                <p>
                  Create accurate subtitles for YouTube, podcasts, and social media.
                  Export directly to YouTube-compatible formats.
                </p>
              </div>
              <div className="use-case-card">
                <h3>Journalists & Researchers</h3>
                <p>
                  Transcribe interviews with confidence scoring to quickly identify
                  unclear sections that need verification.
                </p>
              </div>
              <div className="use-case-card">
                <h3>Legal & Medical</h3>
                <p>
                  High-accuracy transcription with version history for compliance.
                  Secure sharing with access controls.
                </p>
              </div>
              <div className="use-case-card">
                <h3>Education</h3>
                <p>
                  Make lectures and educational content accessible with accurate
                  captions and searchable transcripts.
                </p>
              </div>
            </div>
          </section>

          {/* Subtitle Export Section */}
          <section className="about-section subtitle-export-section">
            <h2>Multi-Format Subtitle Export</h2>
            <p className="section-intro">
              Export your transcripts as perfectly-timed subtitles in any format you need.
              Every word includes precise timestamps for seamless synchronization.
            </p>

            <div className="subtitle-formats-grid">
              <div className="subtitle-format-card">
                <div className="format-header">
                  <span className="format-badge">SRT</span>
                  <span className="format-name">SubRip</span>
                </div>
                <p className="format-description">
                  The universal standard. Works with virtually every video player, editing software,
                  and streaming platform.
                </p>
                <ul className="format-uses">
                  <li>Adobe Premiere Pro</li>
                  <li>Final Cut Pro</li>
                  <li>VLC Media Player</li>
                  <li>Most video platforms</li>
                </ul>
              </div>

              <div className="subtitle-format-card">
                <div className="format-header">
                  <span className="format-badge vtt">VTT</span>
                  <span className="format-name">WebVTT</span>
                </div>
                <p className="format-description">
                  The web standard for HTML5 video. Native support on YouTube, Vimeo,
                  and all modern browsers.
                </p>
                <ul className="format-uses">
                  <li>YouTube upload</li>
                  <li>HTML5 video</li>
                  <li>Web applications</li>
                  <li>Streaming services</li>
                </ul>
              </div>

              <div className="subtitle-format-card">
                <div className="format-header">
                  <span className="format-badge ass">ASS</span>
                  <span className="format-name">Advanced SubStation</span>
                </div>
                <p className="format-description">
                  Advanced styling and positioning. Perfect for professional productions
                  requiring custom fonts, colors, and effects.
                </p>
                <ul className="format-uses">
                  <li>Professional video</li>
                  <li>Custom styling</li>
                  <li>Anime & fansubs</li>
                  <li>Complex layouts</li>
                </ul>
              </div>

              <div className="subtitle-format-card">
                <div className="format-header">
                  <span className="format-badge sbv">SBV</span>
                  <span className="format-name">YouTube Simple</span>
                </div>
                <p className="format-description">
                  YouTube's native subtitle format. Lightweight and optimized for
                  quick uploads to YouTube Studio.
                </p>
                <ul className="format-uses">
                  <li>YouTube Studio</li>
                  <li>Quick uploads</li>
                  <li>Simple captions</li>
                  <li>Minimal formatting</li>
                </ul>
              </div>
            </div>

            <div className="export-features">
              <div className="export-feature">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <h4>Precise Timing</h4>
                  <p>Word-level timestamps ensure perfect sync with your audio</p>
                </div>
              </div>
              <div className="export-feature">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                </svg>
                <div>
                  <h4>Smart Line Breaking</h4>
                  <p>Automatic segmentation for optimal readability (1-7 seconds per caption)</p>
                </div>
              </div>
              <div className="export-feature">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
                <div>
                  <h4>Edit-Aware Export</h4>
                  <p>Only exports your approved words — deleted content is automatically excluded</p>
                </div>
              </div>
            </div>
          </section>

          {/* Technology Section */}
          <section className="about-section technology-section">
            <h2>Powered by Advanced AI</h2>
            <div className="technology-content">
              <p>
                Rec-Chord leverages state-of-the-art speech recognition models including NVIDIA's
                Parakeet TDT architecture to deliver industry-leading accuracy. Our AI doesn't just
                transcribe — it analyzes every word to give you confidence scores, helping you
                focus your review time where it matters most.
              </p>
              <div className="tech-highlights">
                <div className="tech-item">
                  <span className="tech-label">Accuracy</span>
                  <span className="tech-value">95%+ on clear audio</span>
                </div>
                <div className="tech-item">
                  <span className="tech-label">Speed</span>
                  <span className="tech-value">Real-time processing</span>
                </div>
                <div className="tech-item">
                  <span className="tech-label">Formats</span>
                  <span className="tech-value">20+ audio formats + video</span>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="about-cta-section">
            <h2>Ready to Get Started?</h2>
            <p>
              Experience the difference that word-level confidence scoring and precise
              timestamps can make in your workflow.
            </p>
            <div className="cta-buttons">
              <Link to="/" className="cta-button primary">Try Rec-Chord Free</Link>
              <Link to="/plans-and-payment" className="cta-button secondary">View Plans</Link>
            </div>
          </section>

          {/* Contact */}
          <section className="about-contact-section">
            <h2>Questions?</h2>
            <p>
              We're here to help. Reach out to our team at{' '}
              <a href="mailto:support@raindragon.ai">support@raindragon.ai</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}

export default About;
